import { connect } from 'react-redux'
import Counter from '../Components/Counter'
import { mapStateToProps, mapDispatchToProps } from '../Utils/mapToProps'

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Counter)
